export default class ActivityRegistrationRequest {
    name: string;
    isSSNMandatory: boolean;
    constructor(
        name: string,
        isSSNMandatory: boolean,
    ) {
        this.name = name;
        this.isSSNMandatory = isSSNMandatory;
    }
}